import { render, staticRenderFns } from "./officialWebsiteAlert.vue?vue&type=template&id=b71f5e26&scoped=true"
import script from "./officialWebsiteAlert.vue?vue&type=script&lang=js"
export * from "./officialWebsiteAlert.vue?vue&type=script&lang=js"
import style0 from "./officialWebsiteAlert.vue?vue&type=style&index=0&id=b71f5e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71f5e26",
  null
  
)

export default component.exports